export default {
  body: {
    margin: 0,
    padding: 0
  },
  '.icon-link': {
    display: 'none'
  },
  '.with-overlay': {
    overflow: 'hidden'
  }
};

if (typeof body !== 'undefined' && body && body === Object(body) && Object.isExtensible(body) && !body.hasOwnProperty('__filemeta')) {
  Object.defineProperty(body, '__filemeta', {
    configurable: true,
    value: {
      name: "body",
      filename: "node_modules/gatsby-theme-docz/src/theme/global.js"
    }
  });
}